import React, { useEffect, useMemo, useState, useLayoutEffect } from 'react';
import { withTabBackButton, WithTabBackButtonStateProps } from 'components/tab';
import SynchTripCard from './SynchTripCard';
import RMButton from 'components/customComponents/Controls/RMButton';
import { IStyle } from 'Styles';
import { useRMDispatch } from 'redux/hooks';
import { setHarvestingContentView } from 'redux/reducers/synchrotronTripReducer';
import { EHarvestingView } from '../constants';
import { useCrystalStates } from '../Crystal/hooks';
import { useApplyCrystalsToTrip, useFetchAllSynchTrips } from './hooks';
import { useAllSynchTrips, useCrystalTrips } from 'redux/hooks/synchrotron';
import { useCrystals, useCurrentTripCheckedCrystals } from 'redux/hooks/crystal';
import { getSelectedTripIdByCrystalId } from '../Crystal/utils';
import { FmlxButton } from 'fmlx-common-ui';

const SelectSynchrotron = (props: WithTabBackButtonStateProps) => {
  const { setHandleOnTabBackPress } = props;
  const [selectedTrip, setSelectedTrip] = useState(0);
  const dispatch = useRMDispatch();
  const applyChanges = useApplyCrystalsToTrip(selectedTrip, setHandleOnTabBackPress);
  const fetchSynchTrips = useFetchAllSynchTrips();
  const allSynchTrips = useAllSynchTrips();
  const { harvestingContentView } = useCrystalStates();
  const crystalIds = useCurrentTripCheckedCrystals();
  const crystals = useCrystals();
  const crystalTrips = useCrystalTrips();

  const onSelectTrip = (tripId: number) => {
    if (tripId === selectedTrip) {
      setSelectedTrip(0);
      return;
    }
    setSelectedTrip(tripId);
  };

  useEffect(() => {
    fetchSynchTrips();
  }, [fetchSynchTrips]);

  useLayoutEffect(() => {
    if (harvestingContentView === EHarvestingView.SELECTTRIP) {
      setHandleOnTabBackPress(
        () => () => dispatch(setHarvestingContentView(EHarvestingView.HARVESTING)),
      );
      const currentSelectedCrystalId = crystalIds?.length ? crystalIds[0] : -1;
      setSelectedTrip(
        getSelectedTripIdByCrystalId(
          crystalTrips,
          crystals?.find((crystal) => crystal.id === currentSelectedCrystalId).id,
        ),
      );
    }
  }, [setHandleOnTabBackPress, harvestingContentView]);

  const renderTrips = useMemo(() => {
    return allSynchTrips?.map((trip) => (
      <SynchTripCard
        key={`stc${trip.id}`}
        onClick={() => onSelectTrip(trip.id)}
        isSelected={trip.id === selectedTrip}
        synchTripName={trip.synchTripName}
        beamLine={trip.beamLine}
        dataCollectionDate={trip.dataCollectionDate}
        detectorType={trip.detectorType}
        status={trip.status}
      />
    ));
  }, [allSynchTrips, selectedTrip]);

  return (
    <>
      <div id='exp-selectsynchrotron-container' style={styles.listDiv}>{renderTrips}</div>
      <div id='exp-selectsynchrotron-actions' className="absolute bottom-6 right-0 mr-4">
        <RMButton
          id='exp-selectsynchrotron-apply-button'
          customStyle={styles.save}
          onClick={applyChanges}
          disabled={selectedTrip === 0}
          label="Apply"
          type={FmlxButton.Type.POSITIVE}
        ></RMButton>
      </div>
    </>
  );
};

export default withTabBackButton(SelectSynchrotron);
const styles: IStyle = {
  save: {
    backgroundColor: '#4AAE53',
    width: '5.5rem',
  },
  listDiv: {
    height: '72vh',
    overflow: 'auto',
  },
};
